











import { Component, Prop, Vue } from "vue-property-decorator";
import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HSpecColumnList from "@/general/components/pages/parts/PointHistoryList/HSpecColumnList.vue";

@Component({
  components: {
    HContainer,
    HSpecColumnList
  }
})
export default class HBorderPanel extends Vue {
  @Prop({ type: Number, required: true }) redemptionType!: number;
  @Prop({ type: Array, required: true }) giftCode!: any[];

  get giftCodeDetails() {
    const { giftCode } = this;
    const label = "ギフトコード";
    const detail = giftCode;

    const resultGiftCodeArray = [
      {
        label,
        detail
      }
    ];

    return resultGiftCodeArray;
  }
}
